<template>
    <button 
        :class="[
            'p-3 rounded-lg font-semibold w-full uppercase text-xl',
            height,
            max_width,
            {
            'bg-theme-primary text-white cursor-pointer': !is_secondary && !disabled && !loading && !is_error,
            'bg-white border-2 border-theme-primary text-theme-primary ': is_secondary && !disabled && !loading,
            'bg-red-600 border-2 text-white': is_error && !disabled && !loading,
            'bg-gray-300 cursor-default pointer-events-none text-white': loading || disabled
            },
            (!loading && !disabled) ? theme : ''  // Apply theme only when enabled
        ]" 
        :disabled="loading || disabled" 
        @click="clicked"
        >
        <div class="flex justify-center relative w-full h-full items-center">
            <svg 
                v-show="loading" 
                version="1.1" 
                id="L9" 
                class="h-12 w-12 animate-spin absolute -mt-6" 
                xmlns="http://www.w3.org/2000/svg" 
                xmlns:xlink="http://www.w3.org/1999/xlink" 
                viewBox="0 0 100 100" 
                enable-background="new 0 0 0 0" 
                xml:space="preserve"
            >
                <path 
                    fill="#24BF23" 
                    d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                />
            </svg>

            <span 
                v-text="button_text" 
                :class="text_size" 
                class="absolute"
            />
        </div>
    </button>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    props:{
        button_text:{
            type: String,
            required: true,
        },
        height:{
            type: String,
            required:false,
            default:'h-12',
        },
        text_size:{
            type: String,
            required:false,
        },
        max_width:{
            type:String,
            required:false,
        },
        disabled:{
            type:Boolean,
            required:false,
        },
        is_secondary: {
            type: Boolean,
            default: false,
        },
        is_error: {
            type: Boolean,
            default: false,
        },
        theme:{
            type:String,
            required:false,
        },
        loading:{
            type:Boolean,
            required:false,
        }
    },
    data(){
        return {
            disasbled:false,
        }
    },
    methods:{
        clicked(){
            if(this.disabled){
                console.log('');
            } else {
                this.$emit('clicked');
            }
            
        }
    }
})
</script>

<style scoped>
.loading-color{
    background-color: #297D28;
}

.bg-white {
    background-color: white !important;
}
.cursor-pointer {
    cursor: pointer !important;
}
</style>